module.exports = __webpack_public_path__ + "img/1-5.cc4e9d66.svg";